/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="93.91"
        height="92.96"
        viewBox="0 0 93.91 92.96"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="none"
          d="m61.39 39.51-19-20"/>
        <path
          fill="#0e497b"
          d="m43.47 18.47 19 20-2.17 2.07-19-20 2.17-2.07z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="m55.39 63.51-23 8"/>
        <path
          fill="#0e497b"
          d="m54.89 62.09.99 2.83-23 8-.99-2.83 23-8z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M16.92 59.06a17 17 0 1 0 15 9 17 17 0 0 0-15-9m0 3a14 14 0 1 1-6.56 1.65 14 14 0 0 1 6.56-1.65"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M73.37 35a20.5 20.5 0 1 0 18.12 10.84A20.51 20.51 0 0 0 73.37 35m0 3a17.51 17.51 0 1 1-8.23 2.07A17.51 17.51 0 0 1 73.37 38"
          className="icon-fill icon-accent"/><path
          fill="#0e497b"
          d="M35.49 0a11.42 11.42 0 1 0 10.07 6 11.42 11.42 0 0 0-10.07-6m0 3a8.42 8.42 0 1 1-4 1 8.42 8.42 0 0 1 4-1"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreeConnectedNodesIcon';

export default Icon;
